var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { isNullOrUndefined } from 'util';
import { config } from '../../../config/config';
import { AllFrontendSettingsCommand } from '../../commands/visitor/all.frontend.settings.command';
import { BaseComponent } from '../../common/components/base.component';
import { PageSpinnerComponent } from '../../common/components/page.spinner/page.spinner.component';
import { localStorageKeys } from '../../common/constants/local.storage.keys';
import { HubVisitorFeatureToggle } from '../../models/hub/hub.visitor.feature.toggle';
import { HubVisitorPromotionImage } from '../../models/hub/hub.visitor.promotion.image';
import { CustomizationApiService } from '../../services/customization.api.service';
import { ImageService } from '../../services/image.service';
import { AllFrontendSettingsStore, VisitorCalendarStore, VisitorDataCache, VisitorStyleStore, } from '../../stores/visitor.calendar.store';
import { VisitorCalendarComponent } from './calendar/visitor.calendar.component';
import { VisitorCreateEventComponent } from './create.event/create.event.component';
import { VisitorCreatePlaceComponent } from './create.place/create.place.component';
import { ModalService } from '../../common/services/modal.service';
import { VisitorPlaceMapComponent } from './place.map/visitor.place.map.component';
var VisitorComponent = /** @class */ (function (_super) {
    __extends(VisitorComponent, _super);
    function VisitorComponent(customizationApiService, visitorStyleStore, imageService, router, modalService, allFrontendSettingsStore, visitorCalendarStore, activatedRoute) {
        var _this = _super.call(this, { activatedRoute: activatedRoute }) || this;
        _this.customizationApiService = customizationApiService;
        _this.visitorStyleStore = visitorStyleStore;
        _this.imageService = imageService;
        _this.router = router;
        _this.modalService = modalService;
        _this.allFrontendSettingsStore = allFrontendSettingsStore;
        _this.visitorCalendarStore = visitorCalendarStore;
        _this.activatedRoute = activatedRoute;
        _this.isSideBarOpened = false;
        _this.hubName = null;
        _this.isShowUpgradeBrowser = true;
        // public customerSettings = new VisitorSettingsCommand();
        _this.featuresToggle = new HubVisitorFeatureToggle();
        _this.allFrontendSettings = new AllFrontendSettingsCommand();
        _this.isSettingsLoaded = false;
        _this.visitorPromotionImage = new HubVisitorPromotionImage();
        _this.defaultVisitorPromotionImg = config.defaultVisitorPromotionImageUrl;
        return _this;
    }
    VisitorComponent.prototype.ngOnInit = function () {
        var _this = this;
        var hubName = this.allRouteParams.hubName;
        this.hubName = hubName;
        this.spinner.show();
        try {
            this.customizationApiService
                .getAllFrontendSettings(this.hubName)
                .subscribe(function (allSettings) {
                if (!allSettings) {
                    // alert(`Account ${this.hubName} not found, please verify!`);
                    console.error("Account " + _this.hubName + " not found, please verify!");
                    return;
                }
                // this storage records the selected place category, which is used to bring the selected category to map view
                localStorage.removeItem(localStorageKeys.selectedPlaceCategory);
                _this.allFrontendSettings = allSettings;
                var settings = allSettings.customSettings;
                localStorage.setItem(localStorageKeys.timezoneFormatterDefault, allSettings.customSettings.timezoneFormatter);
                _this.setCustomerColor(settings.Style);
                var logoUrl = isNullOrUndefined(settings.logo) ||
                    isNullOrUndefined(settings.logo.isDefault) ||
                    settings.logo.isDefault
                    ? config.defaultLogoUrl
                    : settings.logo.url;
                VisitorDataCache.logo = _this.imageService.imageSourceUrl(logoUrl);
                VisitorDataCache.placeCategories = allSettings.placeCategories;
                _this.allFrontendSettingsStore.allFrontendSettingsCommand.next(_this.allFrontendSettings);
                // for event details modal
                localStorage.setItem(localStorageKeys.visitorSettings, JSON.stringify(_this.allFrontendSettings.customSettings));
                _this.isSettingsLoaded = true;
            });
        }
        catch (e) {
            alert(e);
        }
        finally {
            setTimeout(function () {
                _this.spinner.hide();
            });
        }
    };
    Object.defineProperty(VisitorComponent.prototype, "isNeedSideBar", {
        get: function () {
            try {
                /**
                 * VisitorPlaceMapComponent needs to have topbar (in topbar mode) is because the multi-level nested dropdown menu would have UX issue
                 * after view changed. So keep the topbar alive but hide it when switching to place map view
                 * */
                return (this._outlet.activatedRoute.component === VisitorCalendarComponent ||
                    //this._outlet.activatedRoute.component === VisitorEventMapComponent ||
                    (!this.allFrontendSettings.customSettings.menuStyle.isSideBar &&
                        this._outlet.activatedRoute.component === VisitorPlaceMapComponent) ||
                    this._outlet.activatedRoute.component === VisitorCreateEventComponent ||
                    this._outlet.activatedRoute.component === VisitorCreatePlaceComponent);
            }
            catch (e) {
                return true;
            }
            // don't know why using the Component Name VisitorTripComponent causes a script error
            //this._outlet.activatedRoute.component.toString().indexOf('VisitorTripComponent') !== -1 ;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisitorComponent.prototype, "isHideTopBar", {
        /**
         * VisitorPlaceMapComponent needs to have topbar (in topbar mode) is because the multi-level nested dropdown menu would have UX issue
         * after view changed. So keep the topbar alive but hide it when switching to place map view
         * */
        get: function () {
            if (!this.isSettingsLoaded || !this._outlet)
                return false;
            return (this._outlet.activatedRoute.component === VisitorPlaceMapComponent &&
                !this.allFrontendSettings.customSettings.menuStyle.isSideBar);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisitorComponent.prototype, "isNoTopMenuForMobile", {
        get: function () {
            return this._outlet.activatedRoute.component.toString().indexOf('VisitorTripComponent') !== -1;
        },
        enumerable: true,
        configurable: true
    });
    VisitorComponent.prototype.upgradeBrowser = function () {
        window.open('https://browser-update.org/update-browser.html?force_outdated=true#3.3.15:browser-update.org', '_blank');
    };
    VisitorComponent.prototype.hideUpgradeBrowser = function () {
        this.isShowUpgradeBrowser = false;
    };
    // /**
    //  * solve the browser's back button is triggered, event calendar shows empty content issue
    //  * now prevent default in event.details.modal.component.ts
    //  * */
    // @HostListener('window:popstate', ['$event'])
    // public hashChanged($event) {
    //     if (this.isScriptSolution) {
    //         setTimeout(() => {
    //             const storage = localStorage.getItem(localStorageKeys.eventQueryCommand);
    //             let actionCommand = storage ? JSON.parse(storage) : new VisitorCalendarActionCommand();
    //             console.log('command from storage?', storage);
    //             console.log('command load', actionCommand);
    //             this.visitorCalendarStore.actionCommand.next(actionCommand);
    //             this.visitorStyleStore.styleCommand.next(new VisitorStyleCommand());
    //             console.log('command sent');
    //             this.router.navigateByUrl(
    //                 getRouteUrl(routeConfigs.visitor.eventCalendar, {
    //                     hubName: this.hubName,
    //                 }),
    //                 { skipLocationChange: this.noChangeUrlWhenRedirect }
    //             );
    //         });
    //     }
    // }
    VisitorComponent.prototype.setCustomerColor = function (data) {
        if (!data) {
            return;
        }
        var head = document.getElementsByTagName('head')[0];
        var s = document.createElement('style');
        s.setAttribute('type', 'text/css');
        var css = '';
        if (data.defaultButton.backgroundColor) {
            css += "--default-btn-background-color: " + data.defaultButton.backgroundColor + ";";
        }
        if (data.eventButton.backgroundColor) {
            css += "--event-btn-background-color: " + data.eventButton.backgroundColor + ";";
            // let rgb = hexToRgb(data.eventButton.backgroundColor);
            // console.log(`isLightColor(rgb): ${isLightColor(rgb)}`);
        }
        if (data.placeButton.backgroundColor) {
            css += "--place-btn-background-color: " + data.placeButton.backgroundColor + ";";
        }
        if (data.pinnedEventBorder.borderColor) {
            css += "--pinned-event-border-color: " + data.pinnedEventBorder.borderColor + ";";
        }
        if (data.detailButton.backgroundColor) {
            css += "--detail-btn-background-color: " + data.detailButton.backgroundColor + ";";
        }
        if (data.sidebarUnderline.color) {
            css += "--sidebar-underline-color: " + data.sidebarUnderline.color + ";";
        }
        s.appendChild(document.createTextNode("\n                :root {\n                  " + css + "\n                }\n            "));
        head.appendChild(s);
    };
    return VisitorComponent;
}(BaseComponent));
export { VisitorComponent };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/visitor/visitor.component.ts.pre-build-optimizer.js